<header class="header">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="logo">
          <a href="/">
            <img src="assets/images/logo.png" alt="pdf to word" class="logo-img">
          </a>
        </div>
      </div>
      <div class="col-md-6">
        <nav class="nav-menu">
        </nav>
      </div>
    </div>
  </div>
</header>
